/* DeleteButton.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0fKRyPnQyn%7Bvisibility%3Ahidden%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._1mT5xdWVPG%7Bposition%3Aabsolute%7D%0A._2IhTon4F84%7Btop%3Avar(--ds-space-negative-100%2C-8px)%7D%0A._4ApkO24F84%7Bright%3Avar(--ds-space-negative-100%2C-8px)%7D%0A._42Yu6B7dHp%7Bz-index%3A1%7D%0A._2CTNV7dnbC%20span%7Bline-height%3A0%7D%0A._2IhTon5UaJ%7Btop%3Avar(--ds-space-negative-050%2C-4px)%7D%0A._4ApkO25UaJ%7Bright%3Avar(--ds-space-negative-050%2C-4px)%7D%0A._39xV0270UD%7Bwidth%3A18px%7D%0A._0jFU0V70UD%7Bheight%3A18px%7D");










import Button, { type ButtonProps } from '@atlaskit/button/standard-button';
import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import { Box } from '@atlaskit/primitives/compiled/box';
import { deleteEmojiLabel } from '../../util/constants';
import { isRefreshEmojiPickerEnabled } from './isRefreshEmojiPickerEnabled';
import { emojiDeleteButton } from './styles';
const styles = {
  boxWrapperStyle: "_39xV0270UD _0jFU0V70UD"
};
const deleteButton = null;
const refreshedDeleteButton = null;

/**
 * Test id for wrapper Emoji delete button
 */
export const RENDER_EMOJI_DELETE_BUTTON_TESTID = 'render-emoji-delete-button';
const DeleteButton = (props: ButtonProps): JSX.Element => {
  const isRefreshEnabled = isRefreshEmojiPickerEnabled();
  return <span
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  className={ax(["_0fKRyPnQyn _3iDTPbQ4SZ _1mT5xdWVPG _2IhTon4F84 _4ApkO24F84 _42Yu6B7dHp _2CTNV7dnbC", isRefreshEnabled && "_2IhTon5UaJ _4ApkO25UaJ", emojiDeleteButton])} data-testid={RENDER_EMOJI_DELETE_BUTTON_TESTID}>
			<Button iconBefore={<Box xcss={styles.boxWrapperStyle}>
						{isRefreshEnabled ? <CrossCircleIcon label={deleteEmojiLabel} color={"var(--ds-icon, #292A2E)"} size="medium" /> : <CrossCircleIcon label={deleteEmojiLabel} color={"var(--ds-text-subtle, #505258)"} size="small" />}
					</Box>} onClick={props.onClick}
    // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
    appearance="subtle-link" spacing="none" testId="emoji-delete-button" tabIndex={-1} />
		</span>;
};
export default DeleteButton;